import { useState, useEffect } from 'react'
import { GalleryItem } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'

import play from 'public/play.svg'
import { getYoutubeId } from '@/helpers/utils'
import Lightbox from '../Lightbox'
import styles from './Gallery.module.scss'

interface IProps {
  gallery: GalleryItem[]
}

const CompanyGallerySecond = ({ gallery }: IProps) => {
  const { t } = useTranslation('company')
  const [isOpen, setOpen] = useState<boolean>(false)
  const [photoIndex, setPhotoIndex] = useState<number>(0)
  const [isMobile, setIsMobile] = useState(false)

  const data = gallery.map((item) => ({
    url:
      item.type === 'Video'
        ? `https://www.youtube.com/embed/${getYoutubeId(item.assetUrl)}`
        : item.assetUrl,
    type: item.type === 'Video' ? 'video' : 'photo',
    altTag: item.description,
  }))

  useEffect(() => {
    window.innerWidth < 820 ? setIsMobile(true) : setIsMobile(false)
  })

  return (
    <div className='md:py-10 my-14 md:my-4'>
      {isOpen && (
        <Lightbox
          data={data}
          startIndex={photoIndex}
          onCloseCallback={() => setOpen(false)}
          showResourceCount
        />
      )}
      <h2 className='text-2xl md:text-4xl font-medium mb-8 mt-4 text-center'>
        {t('company:images_videos')}
      </h2>

      {isMobile ? (
        <div className='flex flex-col justify-between'>
          {gallery.map((item, index) => {
            if (index > 5 && gallery.length > 7) {
              return null
            }
            return (
              <button
                type='button'
                key={index}
                className={`${
                  !isMobile && styles[`block-${index + 1}`]
                } relative rounded-2xl bg-cover bg-center my-5 padding-y-20 shadow-md w-full h-full hover:shadow-gallery ease-in duration-100 overflow-hidden`}
                onClick={() => (setOpen(true), setPhotoIndex(index))}
              >
                <img
                  loading='lazy'
                  src={item.thumbnailUrl}
                  alt=''
                  className='w-full h-full object-cover'
                />
                {item.type === 'Video' && (
                  <img
                    src={play.src}
                    width={60}
                    className='absolute mx-auto left-0 right-0 top-1/2 -translate-y-1/2'
                    alt=''
                  />
                )}
              </button>
            )
          })}
          {gallery.length > 7 && (
            <button
              type='button'
              key={6}
              className={`${
                !isMobile && styles[`block-7`]
              } h-96 rounded-2xl border-4 bg-primary`}
              onClick={() => (setOpen(true), setPhotoIndex(6))}
            >
              +{gallery.length - 6} photos
            </button>
          )}
        </div>
      ) : (
        <div
          className={`${
            gallery.length > 3
              ? styles['gallery-container']
              : styles['gallery-row']
          }`}
        >
          {gallery.map((item, index) => {
            if (index > 5 && gallery.length > 7) {
              return null
            }
            return (
              <button
                type='button'
                key={index}
                className={`${
                  styles[`block-${index + 1}`]
                } rounded-2xl bg-cover bg-centershadow-md hover:shadow-gallery ease-in duration-100 overflow-hidden relative`}
                onClick={() => (setOpen(true), setPhotoIndex(index))}
              >
                <img
                  loading='lazy'
                  src={item.thumbnailUrl}
                  alt=''
                  className='w-full h-full object-cover'
                />
                {item.type === 'Video' && (
                  <img
                    src={play.src}
                    width={60}
                    className='absolute mx-auto left-0 right-0 top-1/2 -translate-y-1/2'
                    alt=''
                  />
                )}
              </button>
            )
          })}
          {gallery.length > 7 && (
            <button
              type='button'
              key={6}
              className={`${styles[`block-7`]} h-34 rounded-2xl border-2`}
              onClick={() => (setOpen(true), setPhotoIndex(6))}
            >
              +{gallery.length - 6} photos
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default CompanyGallerySecond
